







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  PageMetadataDto
} from '@eurogast/hub-client-typescript';

@Component({})
export default class Pagination extends Vue {
  @Prop({ required: true })
  public page: PageMetadataDto;
  public currentPage = 0;

  public mounted() {
    this.currentPage = this.page.number + 1;
  }

  @Watch('page')
  public onPageChange(newPage: PageMetadataDto) {
    this.currentPage = newPage.number + 1;
  }

  get isFirstPage() {
    return this.page.number === this.firstPage;
  }

  get isLastPage() {
    return this.page.number === this.lastPage;
  }

  get firstPage() {
    return 0;
  }

  get lastPage() {
    return this.page.totalPages > 0 ? this.page.totalPages - 1 : 0;
  }

  public goToPage(pageNumber: number) {
    if (pageNumber < this.firstPage) {
      pageNumber = this.firstPage;
    } else if (pageNumber > this.lastPage) {
      pageNumber = this.lastPage;
    }
    this.$emit('change', pageNumber);
  }

  public goBack() {
    this.goToPage(this.page.number - 1);
  }

  public goForward() {
    this.goToPage(this.page.number + 1);
  }
}
